import {ApDynGridColumnConfigBase}                 from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridStatusColumnConfig
}                                                  from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                                  from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                  from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridEditColumnConfig
}                                                  from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {LanguageStore}                             from '../../stores/translation/language.store';
import {GetRoundNumericPipe}                       from '../../ap-utils';
import {
  ApTranslationService
}                                                  from '../../ap-utils/service/ap-translation.service';
import {
  DropDownButtonData
}                                                  from '../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {EventEmitter, Injectable}                  from '@angular/core';
import {
  ApDynGridPagerConfig,
  IDynGridWizardChoiceData
}                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {ApGridPagerType} from '../../ap-interface';
import {ApIcons}         from '../../ap-interface/enums/layout/ap-icons';
import {SettingsStore}   from '../../stores/base-data/settings.store';
import {nameOf}                                    from '../../ap-core/utils/ap-name-of';
import {IPpPlanningBookingGridItem, PpNoDataValue} from '../types/pp-planning-booking.types';
import {
  IPpEntryPlanBookingGridItem
}                                                  from '../../entry-components/plant-protection-entry-components/plan-booking/pp-plan-booking.types';

/**
 * Service for grid configuration of plant protection
 * Plant-Protection -> Plans
 * Plant-Protection -> Records
 */
@Injectable({
  providedIn: 'root'
})
export class PpPlanningBookingGridConfig {

  constructor(private languageStore: LanguageStore,
              private settingsStore: SettingsStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private translationService: ApTranslationService) {
  }

  public getGridColumns(dropDownActions: DropDownButtonData[]): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        title: 'Global__Status',
        field: nameOf<IPpPlanningBookingGridItem>('Status'),
        class: 'StatusClass',
        description: 'StatusDesc',
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global_Application_Date',
        field: nameOf<IPpPlanningBookingGridItem>('ApplicationDate'),
        tooltip: (dataItem) => dataItem.ApplicationDateTooltip,
        dynCssClass: (dataItem) => dataItem.ApplicationDateItalic ? ' italic' : '',
        sortIndex: 1,
        sortDesc: true,
        width: 80,
        filterable: true,
        headerFilterable: true,
        format: this.languageStore.Listen(s => s.selectedLanguage).getValue().DateFormat,
        template: PropertyTemplate.DATE
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Crop',
        field: nameOf<IPpPlanningBookingGridItem>('Crop'),
        width: 100,
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Base__Fields',
        field: nameOf<IPpPlanningBookingGridItem>('Count'),
        hide: true,
        width: 50,
        tooltip: (dataItem) => dataItem?.FieldsTooltip,
        cssClass: 'right',
        filterType: FilterType.NUMBER,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Area',
        field: nameOf<IPpPlanningBookingGridItem>('Area'),
        hide: true,
        width: 50,
        cssClass: 'right',
        filterType: FilterType.NUMBER,
        filterable: true,
        headerFilterable: true,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [this.settingsStore.FirstSetting?.DigitsAfterDecimalPoint]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: `${this.translationService.translate('Global__Products')}`,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            title: 'AvgShort',
            field: nameOf<IPpPlanningBookingGridItem>('ProductNames'),
            width: 180,
            multiline: true,
            filterable: true,
            headerFilterable: true,
            tooltip: (dataItem: IPpPlanningBookingGridItem) => dataItem?.ProductNamesTooltip
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Sum',
            field: nameOf<IPpPlanningBookingGridItem>('ProductsSum'),
            width: 100,
            multiline: true,
            filterable: true,
            headerFilterable: true,
            tooltip: (dataItem: IPpPlanningBookingGridItem) => dataItem?.ProductsSumTooltip
          })
        ]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__OperationMode',
        field: nameOf<IPpPlanningBookingGridItem>('OperationModeKeyTrans'),
        width: 80,
        multiline: false,
        filterable: true,
        headerFilterable: true,
        hide: true,
        tooltip: (dataItem: IPpPlanningBookingGridItem) => dataItem?.OperationModeKeyTrans
      }),
      new ApDynGridGroupColumnConfig({
        title: `${this.translationService.translate('Global__Water')} [${this.translationService.translate('Unit_l_per_ha')}]`,
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Avg_Symbol',
            field: nameOf<IPpPlanningBookingGridItem>('Avg'),
            width: 60,
            cssClass: 'right', filterType: FilterType.NUMBER, filterable: true,
            template: PropertyTemplate.NUMBER,
            headerFilterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0, {ToReplace: [PpNoDataValue], ReplaceWith: ''}]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Min',
            field: nameOf<IPpPlanningBookingGridItem>('Min'),
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            filterable: true,
            template: PropertyTemplate.NUMBER,
            headerFilterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0, {ToReplace: [PpNoDataValue], ReplaceWith: ''}]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Max',
            field: nameOf<IPpPlanningBookingGridItem>('Max'),
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            filterable: true,
            template: PropertyTemplate.NUMBER,
            headerFilterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0, {ToReplace: [PpNoDataValue], ReplaceWith: ''}]
            }]
          })
        ]
      }),
      new ApDynGridGroupColumnConfig({
        title: `${this.translationService.translate('Global__Sum')} ${this.translationService.translate('Global__Water')}`,
        headerStyle: {'text-align': 'center'},
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: nameOf<IPpPlanningBookingGridItem>('ApplSum'),
            tooltip: (dataItem) => dataItem?.ApplSum >= 0 ? `${dataItem?.ApplSum ?? 0} ${dataItem?.ApplUnit}` : '',
            hide: true,
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            headerFilterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0, {ToReplace: [PpNoDataValue], ReplaceWith: ''}]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<IPpPlanningBookingGridItem>('ApplUnit'),
            hide: true,
            width: 60,
            filterable: true,
            headerFilterable: true
          })
        ]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Note',
        field: nameOf<IPpPlanningBookingGridItem>('Note'),
        width: 100,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridEditColumnConfig({
        data: dropDownActions
      })
    ];
  }

  public getGridPager(options: { text: string, callback: EventEmitter<any> }[]): ApDynGridPagerConfig {
    return new ApDynGridPagerConfig({
      listMassEditing: options.map((option, index) =>
        ({
          id: index,
          name: option.text,
          type: ApGridPagerType.None,
          onSubmit: option.callback
        } as IDynGridWizardChoiceData)),
      iconButtons: [
        {icon: ApIcons.PDF, callback: undefined},
        {icon: ApIcons.XLS, callback: undefined},
      ]
    });
  }
}
